import Vue from 'vue';

export default {
    addOverlayPage(state, payload) {
        let pages = state.overlay.pages;
        pages.push(payload);
        Vue.set(state.overlay, 'isVisible', true);
        Vue.set(state.overlay, 'currentPageIndex', pages.length - 1);
        Vue.set(state.overlay, 'pages', pages);
        Vue.set(state.overlay, 'navDirection', 'add');
    },
    nextOverlayPage(state) {
        let index = state.overlay.currentPageIndex;
        if (index < state.overlay.pages.length - 1) 
            index++;
        Vue.set(state.overlay, 'currentPageIndex', index);
        Vue.set(state.overlay, 'navDirection', 'foreward');
    },
    previousOverlayPage(state) {
        let index = state.overlay.currentPageIndex;
        let pages = state.overlay.pages;
        if (index > 0) {
            pages.splice(index);
            index--;
        }
        Vue.set(state.overlay, 'currentPageIndex', index);
        Vue.set(state.overlay, 'navDirection', 'back');
    },
    closeOverlay(state) {
        Vue.set(state.overlay, 'isVisible', false);
        Vue.set(state.overlay, 'currentPageIndex', 0);
        Vue.set(state.overlay, 'pages', []);
    },

};
